/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import {useIsMobile} from "../../../table/Table";
import {FavoriteRecipeRowSkeletonMobile} from "./FavoriteRecipeRowSkeletonMobile";
import {FavoriteRecipeRowSkeleton} from "./FavoriteRecipeRowSkeleton";

export const FavoriteRecipeSkeleton = () => {
    const isMobile = useIsMobile();

    return isMobile ?
        <>{[...Array(5)].map((item, i) => <FavoriteRecipeRowSkeletonMobile key={i}/>)}</>
        :
        <>{[...Array(5)].map((item, i) => <FavoriteRecipeRowSkeleton key={i}/>)}</>
}

